export enum EnumTipoComunicacao {
    Nenhuma = -1,
    Boleto = 0,
    Pix = 1,
    Bolix = 2,
    Transferencia = 98,
    Dinheiro = 99
}